import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent.js'
import Navigation from '../Navigation/Navigation.js'
import NoContent from '../NoContent/NoContent.js'
import NotAuthorized from '../NotAuthorized/NotAuthorized.js'
import AuthorizationFilter from '../Authorization/AuthorizationFilter.js'

export default class MainView extends WebComponent {

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.oldChild = null
    this.navigationListener = e => {
      // split is used if we have vertical submenu navigation
      this.loadView(e.detail)
    }
    document.addEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)

    this.loadView(getNavigationHash())
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.removeEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
  }

  loadView(linkName) {
    if (isEmpty(linkName)) {
      this.redirectToDefault()
    } else {
      const newChild = this.returnNewChild(linkName)
      if (this.oldChild) {
        this.root.replaceChild(newChild, this.oldChild)
      } else {
        this.root.appendChild(newChild)
      }

      this.oldChild = newChild
    }
  }

  returnNewChild(linkName) {
    if (!new AuthorizationFilter().viewAllowed(linkName)) {
      return new NotAuthorized()
    }
    const Component = Navigation.getComponent(linkName)
    return Component !== undefined ? new Component() : new NoContent()
  }

  redirectToDefault() {
    navigate({to: Navigation.ROUTES.dashboard.url})
  }

  getTemplate() {
    return html`eko-frontend-main-view`
  }
}

customElements.define('eko-frontend-main-view', MainView)
